import { IFormField } from '@migrate/utils/form/form'

interface ConditionalSelectState {
  parent: IFormField
  child: IFormField
  valueMap: any
}
export default class FieldAssumptionProcessor {
  private readonly fields: IFormField[]

  private conditionalHiddens: IFormField[]
  private fieldLookup: Map<string, IFormField>
  private conditionalStates: ConditionalSelectState[] = []

  constructor(fields: IFormField[]) {
    this.fields = fields
    this.fieldLookup = new Map<string, IFormField>()
    this.conditionalHiddens = []

    this.fields.forEach((field) => {
      this.fieldLookup.set(field.name, field)
    })

    this.fields.forEach((field) => {
      if (field.meta.conditionalSelects) {
        field.meta.conditionalSelects.forEach((con) => {
          const childField = this.fieldLookup.get(con.childField)
          if (childField) {
            this.conditionalStates.push({
              parent: field,
              child: childField,
              valueMap: con.valueMap,
            })
          }
        })
      }

      if (field.meta.conditionalHiddens && field.meta.conditionalHiddens.length > 0) {
        this.conditionalHiddens.push(field)
      }
    })
  }

  public updateConditionals() {
    this.fields.forEach((field) => {
      field.state.hidden = false
    })
    this.updateConditionalSelects()
    this.updateConditionalHiddens()
  }

  private updateConditionalHidden(field: IFormField, reset: boolean) {
    if (reset) {
      this.fields.forEach((field) => {
        field.state.hidden = false
      })
    }

    const value = field.value
    if (!value) {
      return
    }
    field.meta
      .conditionalHiddens!.filter((conditional) => {
        return conditional.value === value
      })
      .forEach((conditional) => {
        const hiddenNames = conditional.hiddenNames
        hiddenNames.forEach((name) => {
          const hiddenField = this.fieldLookup.get(name)
          if (hiddenField) {
            hiddenField.state.hidden = true
          }
        })
      })
  }

  private updateConditionalSelect(sel: ConditionalSelectState) {
    const { parent, child, valueMap } = sel
    if (child) {
      const options = child.meta.options
      if (!options || options.length === 0) {
        const parentRef = parent.meta.model?.assumption?.refName ?? parent.name
        const childRef = child.meta.model?.assumption?.refName ?? child.name
        console.warn('Conditional select skipped: child field has no options', {
          parentId: parent.id,
          parentRef,
          childId: child.id,
          childRef,
          entityTypeId: child.meta.entityTypeId ?? parent.meta.entityTypeId,
        })
        return
      }
      const value = parent.value
      if (value) {
        const childValues = valueMap[value] as string[]
        options.forEach((option) => {
          option.hidden = !childValues || childValues.indexOf(option.label) === -1
        })
        const current = child.value
        if (current) {
          let v = null
          options.forEach((option) => {
            if (!option.hidden && current === option.value) {
              v = current
            }
          })
          child.value = v
        }
      } else {
        options.forEach((option) => {
          option.hidden = false
        })
      }
    }
  }

  private updateConditionalSelects() {
    this.conditionalStates.forEach((sel) => {
      this.updateConditionalSelect(sel)
    })
  }

  private updateConditionalHiddens() {
    this.fields.forEach((field) => {
      field.state.hidden = false
    })
    this.conditionalHiddens.forEach((field) => {
      this.updateConditionalHidden(field, false)
    })
  }
}
